package io.github.dautovicharis.charts.demoshared.theme

import androidx.compose.material3.ColorScheme
import androidx.compose.runtime.Composable

@Composable
actual fun dynamicColors(): ColorScheme? = null
